<template>
  <div class="modal-wrapper">
    <div class="modal">
      <div class="modal-header">
        <div class="new-input">
          <span class="miv">N</span>
          <input type="text" placeholder="Търсене" v-model="searchMaterials" />
        </div>
        <span class="miv modal-close" @click="close()">F</span>
      </div>
      <div class="modal-content" v-if="!isComingFromReport">
        <!-- IMPORT TEMPLATE -->
        <div
          v-if="!materials.length"
          class="modal-content-template"
          @click="triggerFileInput()"
        >
          <img
            class="modal-content-template-img desktop"
            src="../../assets/img/table_help.png"
            alt="Структура на таблицата"
          />
          <img
            class="modal-content-template-img mobile"
            src="../../assets/img/table_help_mobile.png"
            alt="Структура на таблицата"
          />
        </div>
        <div
          class="modal-content-item"
          v-for="(material, index) in filteredMaterials"
          :key="`materialModal-${index}-${material.materialName}`"
          :class="{ 'modal-content-check-additional': material.isAdditional }"
          :title="material.materialName"
        >
          <p>{{ material.materialName }}</p>
          <span class="miv" @click="deleteMaterial(index)" title>b</span>
        </div>
        <!-- NO RESULTS -->
        <p
          class="modal-content-no-results"
          v-if="materials.length && !filteredMaterials.length"
        >
          Няма намерени резултати за '
          <strong>{{ this.searchMaterials }}</strong
          >'
        </p>
      </div>
      <div class="modal-content" v-else>
        <div
          class="modal-content-check"
          v-for="(m, i) in filteredMaterials"
          :key="`addMaterialsModal-${i}-${m._id}`"
          :class="{ 'modal-content-check-additional': m.isAdditional }"
          :title="m.materialName"
        >
          <label class="checkbox-wrapper">
            <p>{{ m.materialName }}</p>
            <input type="checkbox" :id="m._id" v-model="m.isSelected" />
            <span class="checkmark"></span>
          </label>
          <div
            class="add-parts-and-suppliers add-parts-and-suppliers--edit"
            v-if="m.rows ? m.rows.length : false"
            @click="adding = i"
          >
            <span class="miv2 edit">8</span>
            <span class="text">Редактирай части и доставчици</span>
          </div>
          <div class="add-parts-and-suppliers" v-else @click="adding = i">
            <span class="miv2 plus">/</span>
            <span class="text">Добави части и доставчици</span>
          </div>
        </div>
        <!-- NO RESULTS -->
        <p
          class="modal-content-no-results"
          v-if="materials.length && !filteredMaterials.length"
        >
          Няма намерени резултати за '
          <strong>{{ this.searchMaterials }}</strong
          >'
        </p>
      </div>
      <div class="modal-footer">
        <div class="btns-select" v-if="isComingFromReport">
          <button class="btn btn-select" @click="toggleMaterials(true)">
            <span class="miv">W</span>
            Всички
          </button>
          <button class="btn btn-select" @click="toggleMaterials(false)">
            <span class="miv">X</span>
            Никой
          </button>
          <button class="btn btn-select" @click="isEditInputModalOpened = true">
            <span class="miv">L</span>
            Нов материал
          </button>
        </div>
        <div v-else>
          <!-- EMPTY DIV FOR THE SPACE-AROUND RULE TO WORK -->
        </div>
        <div class="btns">
          <button
            class="btn btn-excel"
            @click="triggerFileInput()"
            v-if="!isComingFromReport"
          >
            <span class="miv">E</span>
            Нов файл
          </button>
          <input
            ref="uploadMaterials"
            class="input-hide"
            type="file"
            @change="handleFile"
          />
          <button class="btn btn-new" @click="save()">
            <span class="miv">Y</span>
            Запази
          </button>
        </div>
      </div>
    </div>
    <EditInputModal
      v-if="isEditInputModalOpened"
      :isComingFromMaterials="true"
    ></EditInputModal>
    <AddRowsModal
      v-if="adding > -1"
      :item="filteredMaterials[adding]"
      :parts="parts"
      type="material"
      @save="(filteredMaterials[adding].rows = $event), (adding = -1)"
      @close="adding = -1"
    />
  </div>
</template>

<script>
import * as XLSX from 'xlsx';
import EditInputModal from './EditInputModal';
import AddRowsModal from './AddRowsModal';
export default {
  components: {
    EditInputModal,
    AddRowsModal,
  },
  props: [
    'incomingMaterials',
    'isComingFromReport',
    'companyId',
    'projectId',
    'objectId',
    'parts',
  ],
  watch: {
    incomingMaterials() {
      this.initMaterials();
    },
  },
  data() {
    return {
      isEditInputModalOpened: false,
      materials: [],
      searchMaterials: '',
      adding: -1,
    };
  },
  computed: {
    filteredMaterials() {
      return this.filterMaterials();
    },
  },
  methods: {
    triggerFileInput() {
      this.$refs.uploadMaterials.click();
    },
    // EXCEL FILE TO JSON
    handleFile(e) {
      let rABS = true; // true: readAsBinaryString ; false: readAsArrayBuffer
      const files = e.target.files;
      const f = files[0];
      if (f.name.match(`.(xls|XLS|xlsx|XLSX)$`)) {
        const reader = new FileReader();
        reader.onload = (e) => {
          let data = e.target.result;
          if (!rABS) data = new Uint8Array(data);
          const workbook = XLSX.read(data, { type: rABS ? 'binary' : 'array' });

          /* DO SOMETHING WITH workbook HERE */
          const rows = this.workbookToJSON(workbook);
          // SHEET
          for (let row in rows) {
            const keys = Object.keys(rows[row][0]);
            for (let i = 0; i < keys.length; i++) {
              if (
                !(
                  keys[i].toLowerCase().includes('име') ||
                  keys[i].toLowerCase().includes('мерна единица') ||
                  keys[i].toLowerCase().includes('цена')
                )
              ) {
                this.$snotify.error(
                  'Таблицата трябва да има заглавен ред с Име / Мерна единица / Цена'
                );
                return;
              }
            }
            // ROW OBJECT
            for (let item in rows[row]) {
              // ROW DATA
              this.materials.push({
                materialName: rows[row][item][Object.keys(rows[row][item])[0]],
                materialUnit: rows[row][item][Object.keys(rows[row][item])[1]],
                materialPrice: rows[row][item][Object.keys(rows[row][item])[2]],
              });
            }
          }
        };
        if (rABS) reader.readAsBinaryString(f);
        else reader.readAsArrayBuffer(f);
      } else {
        this.$snotify.error('Качените файлове трябва да бъдат .xls или .xlsx');
      }
    },
    workbookToJSON(workbook) {
      var result = {};
      workbook.SheetNames.forEach((sheetName) => {
        var roa = XLSX.utils.sheet_to_row_object_array(
          workbook.Sheets[sheetName]
        );
        if (roa.length > 0) {
          result[sheetName] = roa;
        }
      });
      return result;
    },
    filterMaterials() {
      return this.materials.filter((m) => {
        return m.materialName
          .toLowerCase()
          .includes(this.searchMaterials.toLowerCase());
      });
    },
    toggleMaterials(toggle) {
      // If searching select only results
      if (this.searchMaterials.length) {
        const tempFilteredMaterials = this.filterMaterials();
        this.materials.forEach((m, index) => {
          tempFilteredMaterials.forEach((mu) => {
            if (mu._id === m._id) {
              let material = m;
              material.isSelected = toggle;

              this.$set(this.materials, index, material);
            }
          });
        });
      }
      // Otherwise select/deselect all
      else {
        this.materials.forEach((m, index) => {
          const material = m;
          material.isSelected = toggle;

          this.$set(this.materials, index, material);
        });
      }
    },
    // Handle added material from EditInput
    handleAdd(newMaterial) {
      let url = `${process.env.VUE_APP_BASE_URI}/company/${this.companyId}`;
      this.$http
        .get(url)
        .then((response) => {
          const company = response.data;
          // get index of selected project
          const indexOfProject = company.projects.findIndex(
            (p) => p._id === this.projectId
          );
          // get index of selected object
          const indexOfObject = company.projects[
            indexOfProject
          ].objects.findIndex((o) => o._id === this.objectId);

          company.projects[indexOfProject].objects[
            indexOfObject
          ].materials.unshift(newMaterial);

          // make the post request
          let url = `${process.env.VUE_APP_BASE_URI}/company/${company._id}`;

          this.$http
            .put(url, company)
            .then(() => {
              this.$snotify.success('Успешно добавяне на нов материал!');
              this.$parent.$emit('getMaterialsAgain');
            })
            .catch((error) => {
              console.log(error);
              this.$snotify.error('Нещо се обърка! Моля опитайте отново.');
            });
        })
        .catch((error) => console.log(error));
    },
    deleteMaterial(i) {
      this.materials.splice(i, 1);
    },
    getSelectedMaterials() {
      return this.materials.filter((m) => {
        return m.isSelected;
      });
    },
    close() {
      this.$parent.$emit('closeAddMaterialsModal');
    },
    save() {
      if (this.isComingFromReport) {
        const sm = this.getSelectedMaterials();

        for (let m of sm) {
          if (m.rows ? !m.rows.length : true) {
            return this.$snotify.error(
              'Трябва да добавите части и доставчици за всеки избран материал'
            );
          }
        }

        this.$parent.$emit('saveAddMaterialsModal', sm);
      } else {
        this.$parent.$emit('saveAddMaterialsModal', this.materials);
      }
    },
    initMaterials() {
      // this.materials = this.incomingMaterials.slice(0);
      this.materials = this.$cloneDeep(this.incomingMaterials);

      this.materials.sort((x, y) => {
        return x.isSelected === y.isSelected ? 0 : x.isSelected ? -1 : 1;
      });

      this.materials.map((m) => {
        if (!m.supplier) {
          m.supplier = '';
        }
        if (!m.part) {
          m.part = '';
        }
      });
    },
    closeEditInputModal() {
      this.isEditInputModalOpened = false;
    },
  },
  mounted() {
    this.initMaterials();
    this.$on('saveMaterialOrActivity', this.handleAdd);
    this.$on('closeEditInputModal', this.closeEditInputModal);
  },
  destroyed() {
    this.$off('saveMaterialOrActivity');
    this.$off('closeEditInputModal');
  },
};
</script>

<style scoped>
.model-wrapper {
  justify-content: center;
}
.modal {
  max-height: initial;
}
.modal-header {
  background: #17643a;
}
.desktop {
  display: initial;
}
.mobile {
  display: none;
}
.modal-content-check .checkbox-wrapper {
  max-width: calc(100% - 247px); /* temp fix */
}
.add-parts-and-suppliers {
  align-items: center;
  color: #3b86ff;
  cursor: pointer;
  display: flex;
  transition: all 0.2s;
  min-width: 250px;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.add-parts-and-suppliers--edit {
  color: #09772e;
}
.add-parts-and-suppliers:hover {
  opacity: 0.8;
}
.add-parts-and-suppliers .text {
  font-weight: 500;
  text-decoration: underline;
}
.add-parts-and-suppliers .miv2 {
  font-size: 20px;
  margin-right: 9px;
}
.add-parts-and-suppliers .miv2.plus {
  transform: rotate(45deg);
}

/* Responsive */
@media screen and (max-width: 1000px) {
  .modal {
    overflow: unset;
    width: 90%;
  }
  .modal-content-item {
    height: 55px;
    width: 100%;
  }
  .modal-content-check {
    flex-direction: column;
    margin-bottom: 5px;
    margin-left: 0;
    margin-right: 0;
     padding-bottom: 5px;
    width: 100%;
  }
  .modal-content-check .checkbox-wrapper {
    width: calc(100% - 20px);
    max-width: calc(100% - 20px);
  }
  .modal-content-check .checkbox-wrapper > p {
    width: 100%;
  }
  .supplier-and-comment {
    margin-bottom: 10px;
  }
}
@media screen and (max-width: 700px) {
  .modal-footer {
    height: 98px;
    flex-direction: column;
  }
  .btn.btn-new {
    margin-bottom: 0.8em;
  }
  .btns-select {
    display: flex;
    justify-content: center;
    margin-top: 1em;
  }
  .btn-select {
    padding: 0 10px;
  }
}
@media screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: initial;
  }
  .modal-header .new-input {
    width: 60%;
  }
  .supplier-and-comment {
    padding: 0 10px;
  }
  .select-wrapper {
    width: 50%;
  }
  .select-wrapper select {
    width: 100%;
  }
}
@media screen and (max-width: 500px) {
  .btns {
    display: flex;
    flex-direction: column;
  }
  .btn.btn-excel {
    margin-bottom: 0.5em;
  }
}
</style>
